import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      // translation file path
      loadPath: "/assets/i18n/{{ns}}/{{lng}}.json",
      // These JSON files are fetched at runtime and, unlike the hashed JS
      // bundle, keep the same URL across deploys, so a browser or CDN happily
      // serves the previous build's copy and any newly added key renders as
      // its raw key name. `npm run build` stamps REACT_APP_BUILD_VERSION so
      // every build requests a URL the caches have not seen.
      queryStringParams: { v: process.env.REACT_APP_BUILD_VERSION || "dev" },
    },
    fallbackLng: "en",
    // disabled in production
    debug: false,
    // can have multiple namespaces, in case you want to divide a huge
    // translation into smaller pieces and load them on demand
    ns: ["common"],
    detection: {
      order: ["path", "cookie", "localStorage", "navigator"],
      lookupFromPathIndex: 0, // Detect language from the URL
    },
    interpolation: {
      espaceValue: false,
      formatSeparator: ",",
    },
    react: {
      wait: true,
    },
  });

export default i18n;
